import { Text, Tooltip, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface SupplierCellProps {
  supplier: { id: number; name: string } | null;
}

export const SupplierCell: React.FC<SupplierCellProps> = ({ supplier }) => (
  <div style={{ height: '80px', display: 'flex', alignItems: 'center', padding: '8px 0', maxWidth: '100%' }}>
    <VStack align='start' spacing={1} maxW='100%'>
      {supplier ? (
        <>
          <Tooltip label={supplier.name} isDisabled={supplier.name.length <= 30}>
            <Text
              fontWeight='semibold'
              fontSize='md'
              color='blue.600'
              lineHeight='1.2'
              maxW='100%'
              wordBreak='break-word'
              whiteSpace='normal'
              noOfLines={2}>
              {supplier.name}
            </Text>
          </Tooltip>
          <Text
            fontSize='sm'
            color='gray.600'
            lineHeight='1.2'
            maxW='100%'
            wordBreak='break-word'
            whiteSpace='normal'
            noOfLines={1}>
            ID: {supplier.id}
          </Text>
        </>
      ) : (
        <Text fontSize='sm' color='gray.500' fontStyle='italic'>
          No supplier data
        </Text>
      )}
    </VStack>
  </div>
);
